/*
 * @Author: Merlin
 * @Date: 2024-02-27 14:21:11
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-11 17:21:13
 * @Description: 
 */
import {useMinesSocket} from '@/socket/game/mines';
import {betableCheck} from '@/common/js/betHelper';
import {b02} from './MinesBackgroundSteps.js';

const {EMIT_MINES_BET}  = useMinesSocket();
export const arr0to24 = Object.freeze(
    [...Array(5*5).keys()]
);

// ↓ 外来方法
const oFnBorrowed = {
    // ↓翻页
    next() {
        this.slide = (
            this.slide === this.totalSlides - 1 
            ? 0
            : this.slide + 1
        );
    },
    // ↓翻页
    prev() {
        this.slide = (
            this.slide === 0
            ? this.totalSlides - 1
            : this.slide - 1
        );
    },
    // ↓ 计算当前页码 
    check() {
        const arr = this.aDiaondFound || [];
        const iLen = arr.length;
        this.slide = (()=>{
            if (iLen <= 6) return 0;
            if (iLen > 6 && iLen <= 12) return 1;
            if (iLen > 12 && iLen <= 18) return 2;
            return 3;
        })();
    },
};

// ↓ 由程序调用的方法
const oFnAsAssistant = {
    toChangeMode(isAuto){
        this.isAutoMode = !!isAuto;
        if (isAuto){
            this.oAutoDialog.switchAutoDialogVisible(true);
        }
    },
    showStepsAnimation(){
        // console.log("this.isShowAnimation =", this.isShowAnimation); 
        const {canvas01} = this.$refs;
        if (!canvas01) return;
        if (!this.isShowAnimation) return;
        this.oStepsAnim = new b02();
        this.oStepsAnim.init(canvas01);
        fnCanvasAnimationRunner(this.oStepsAnim);
    },
    // ↓ 取得核心按钮（选项）的类名 
    getButtonClassName(iNumber){
        // const t01 = performance.now();
        const {iJoinMark, isAutoMode, isShowAnimation, oGameResult} = this;
        const {isSubmiting} = this.oForm;
        const hasChosen = this.round.prediction.includes(iNumber);
        const isBomb = this.fields.includes(iNumber);
        const isLostOnThis = hasChosen && isBomb; // 旧方案： iNumber === this.iLostOn
        const isGameDone = iJoinMark === 2;
        // ↓ 这是手动模式的类名，自动模式时会按情况覆盖它 
        let oClass = {
            'emergence': hasChosen || isGameDone,
            'diamond': hasChosen && !isLostOnThis,
            'bomb': isLostOnThis,
        };
        // ↓ 自动模式 && 未开始游戏
        if (isAutoMode) {
            const toReplace = (
                !isSubmiting
                || iJoinMark === 0
                || this.fields.length === 0
            );
            if (toReplace){
                oClass = {'selected': hasChosen};
            }
        }
        // ↓ 动画模式专用 
        if (isShowAnimation && isLostOnThis && this.sExplosiveClassName){
            oClass[this.sExplosiveClassName] = true;
        }
        const sPicSrc = (()=>{
            if (isAutoMode){
                if (iJoinMark === 0) return ''; // 自动模式在游戏未启动时不显示图 
                if (isBomb) return this.imgBomb;
                if (hasChosen || isGameDone) { //  || iJoinMark > 0
                    return this.imgDiamond;
                }
                return '';
            }
            if (isBomb) return this.imgBomb;
            if (hasChosen || isGameDone) {
                return this.imgDiamond;
            }
            return '';
        })();
        if (sPicSrc){
            oClass.emergence = true; // 有图，必然要添加这个类名 
        }
        let disabled = this.checkIfDisabled(iNumber, hasChosen);
        const oResult = {
            oClass,
            disabled,
            sPicSrc,
            iNumber, 
        };
        // ↓ 耗时 ≈ 0.1ms
        // console.log('计算类名：', (performance.now() - t01).toFixed(1));
        // console.log(`类名信息 ${iNumber}`, sPicSrc);
        return oResult;
    },
    // ↓ 计算那些没有被用户选中的按钮是不是要禁用 
    checkIfDisabled(iNumber, hasChosen){
        if (!this.isAutoMode) {
            return this.iJoinMark != 1; 
        }
        // ↑ 手动模式，↓自动模式 
        // ↓ 自动模式运行中，一定要禁用 
        if (this.oForm.isSubmiting) return true;
        // ↓ 已经选中的项不禁用，给用户减选的机会
        if (hasChosen) return false;
        const {prediction, count} = this;
        return this.hasPredictedAll;
    },
    // ↓ 提交用户的选择到服务器 
    async toEmitBet(oParams){
        this.iJoinMark = 1; 
        this.oJoinStateStore.gameRunning = true;
        const prediction = deepCopy(oParams.prediction); // 手动模式是数字，自动模式是数组 
        let oParOBJ = {
            // type: 0, 1, 2, // 0-1-2 = 开局-下注-(提现|自动模式下注)
            isFast: false,
            frontID: Date.now(),
            amount: this.oForm.amount,
            ...oParams,
        };
        let oRes = await EMIT_MINES_BET(oParOBJ);
        if (this.dealEmitError(oParOBJ, oRes)) {
            return oRes;
        }
        const aAllNumber = [...this.round.prediction];
        if (typeof prediction === 'number') aAllNumber.push(prediction);
        const iSize = new Set(aAllNumber).size;
        const dealWithBigWin = (
            oRes.win // 获胜了 
            && oParams.type > 0 // 非开局阶段
            && !this.isAutoMode // 手动模式
            && (iSize + this.count >= 25) // 大胜
        );
        // ↓ 处理大胜（手动模式专用）后端人员表示： 自动模式输赢都会直接结算啊 
        if (dealWithBigWin){
            console.log("手动大胜，执行提现");
            oParOBJ = {
                type: 2,
                isFast: !!oParams.isFast,
                amount: this.oForm.amount,
                frontID: Date.now(),
            };
            oRes = await EMIT_MINES_BET(oParOBJ); // 提现
            if (this.dealEmitError(oParOBJ, oRes)) {
                return oRes;
            }
            this.oGameResult.bFoundAll = true;
            oParOBJ.prediction = prediction;
            oParOBJ.autoEmit = '❤️'; // 用于调试打印  
        }
        // 测试 -----------------------------------------------
        // if (import.meta.dev && !oRes.win){
        //     setTimeout(this.firstSubmit, 555);
        //     setTimeout(()=>{
        //         this.toEmitBet({ "type": 1, "prediction": 0, });
        //     }, 999);
        // }
        await this.afterEmitBet(oParOBJ, oRes);
        return oRes;
    },
    // ↓ 处理下注出错
    dealEmitError(oParOBJ, oRes){
        oRes ||= {};
        if (import.meta.dev){
            console.log("提交与返回：\n", oParOBJ, '\n', oRes);
        }
        if (oRes.error) {
            // 仅在【手动模式】弹出弹出，自动模式由方法包内部弹出 
            this.isAutoMode || showNegativeNotify(oRes?.error); 
        }else{
            return false; // 没出错
        }
        if (import.meta.dev) {
            console.error("接口报错");
        }
        this.iJoinMark = 0; 
        this.oJoinStateStore.gameRunning = false;
        return true;
    },
    // ↓ 处理游戏结束之后一些表现 
    async afterEmitBet(oParOBJ, oRes){
        const {prediction} = oParOBJ; 
        const sType = prediction?.constructor?.name; 
        const {win, winAmount, fields=[]} = oRes; 
        this.oGameResult.win = !!win;
        if (winAmount) this.oGameResult.winAmount = winAmount;
        if (fields.length) this.round.fields.splice(0, 1/0, ...fields); 
        if(sType === 'Number'){
            this.round.prediction.push(prediction);
        }
        await this.$nextTick();
        // ---- ↓ 用户执行提现 or 自动模式 ↓ ------------------------- 
        if (oParOBJ.type === 2){
            await this.afterUserCashOut(oParOBJ, oRes);
            return;
        }
        if (win) {
            this.oMusic.oAudio.diamond.toPlay();
        }else{
            this.afterLosing(oParOBJ);
        }
    },
    // ↓ 输之后的动作
    async afterLosing(oParOBJ){
        this.iJoinMark = 2;
        this.oJoinStateStore.gameRunning = false;
        this.oMusic.oAudio.explosion.toPlay();
        this.iLostOn = oParOBJ.prediction;
        // ↓ 切换类型，实现爆炸动画 
        this.showExplosiveByClassName();
    },
    // ↓ 变换类名，播放爆炸动画 
    async showExplosiveByClassName(){
        if (!this.isShowAnimation) { // 无动画模式 
            this.sExplosiveClassName = '';
            return;
        }
        for (let idx of Array(8).keys()){
            if (this.iJoinMark != 2) return; // 终止
            const iStep = 1 + idx;
            let sClass = `explosive explosive-${iStep}`;
            if (iStep == 8) sClass = '';
            this.sExplosiveClassName = sClass;
            await Sleep(100);
        }
    },
    // ↓ 手动模式提现之后，或自动模式下注之后 
    async afterUserCashOut(oParOBJ, oRes){
        this.iJoinMark = 2;
        if (oRes.win){
            this.oGameResult.iShowResult = 1;
            this.oMusic.oAudio.win.toPlay();
        }
        await this.$nextTick(); 
        // ↑ 提现与自动模式通用部分 -----------------
        if (!this.isAutoMode){ // ← 手动下注 
            this.oJoinStateStore.gameRunning = false;
            this.timer4CloseResult = setTimeout(() => {
                this.initTheGame();
            }, 4_000);
            return;
        }
        if (this.plan2StopAutoBetting){
            this.plan2StopAutoBetting = false;
            this.oForm.isSubmiting = false;
        }
        if (oRes.win){
            await Sleep(1_000); // 游戏结果逗留时间 
            this.oGameResult.iShowResult = 2;
            await Sleep(600); // 游戏结果退场耗时
        }else{
            this.oMusic.oAudio.explosion.toPlay();
            this.showExplosiveByClassName();
            await Sleep(1_000); // 暂停时间
        }
        this.iJoinMark = 0;
        await Sleep(300); // 暂停时间
    },
};



// ↓ 设定游戏状态，
const oSetGame = {
    // ↓ 初始化：一个新游戏
    initTheGame() {
        this.slide = 0;
        this.iLostOn = -1;
        this.iJoinMark = 0;
        this.round.fields.splice(0, 1/0);
        this.round.prediction.splice(0, 1/0);
        if (this.oGameResult.iShowResult == 1){
            this.oGameResult.iShowResult = 2;
        }
    },
    // ↓ 加载：进行中的游戏
    loadOngoingGame(oRound){
        // console.log("开始加载进行中的游戏");
        // console.log("oRound\n", deepCopy(oRound)); 
        const prediction = deepCopy(oRound.prediction || []);
        this.oGameResult.winAmount = oRound.winAmount;
        this.round.count = oRound.count;
        // ↑赋值后将引发其它事件, ↓所以下方要延迟执行
        setTimeout(() => {
            this.iJoinMark = 1;
            this.round.prediction.splice(0, 1/0, ...prediction);
            this.check();
        }, 600);
    },
};


// ↓用户触发的方法
const oFnUserTriggered= {
    // 点击下注按钮：开局，或提现
    clickOnBetBtn(){
        const {iJoinMark, isAutoMode} = this;
        const isGaming = iJoinMark === 1;
        if (!isGaming && !betableCheck(this.oForm.amount)) {
            return;
        }
        clearTimeout(this.timer4CloseResult);
        this.oGameResult.iShowResult = 0; 
        if (isAutoMode){ // 自动模式
            if (this.oForm.isSubmiting){
                this.plan2StopAutoBetting = true; // 设为 true 表示有计划关停自动模式 
                this.stopInfinity();
            }else{
                this.plan2StopAutoBetting = false; // 设为初始状态 
                this.startInfinity();
            }
            return;
        }
        // ↓ 游戏进行中，执行提现
        if (isGaming) {
            if (this.isDigging){
                return console.log('提现被驳回；上次点击未结束'); 
            }
            this.isDigging = true; // 提现时锁定雷区 
            this.toEmitBet({ type: 2 }).finally(()=>{
                this.isDigging = false;
            });
        }else{
            // 至此还剩下2种可能性：iJoinMark：0未启动, 2游戏结束了
            this.firstSubmit(); // 执行下注（开局）
        }
    },
    // ↓ 自动模式提交
    async autoModeSubmit(){
        console.log("开始提交（自动模式）");
        const prediction = deepCopy(this.round.prediction);
        this.initTheGame();
        this.round.prediction.splice(0, 1/0, ...prediction);
        if (!prediction.length && import.meta.dev) debugger;
        let amount = this.oForm.amount;
        // if (import.meta.env.DEV_MODE && Math.random() < 0.3 && Date.now() < new Date('2025-05-30').getTime()){
        //     amount = 0; 
        // }
        const res = await this.toEmitBet({ 
            type: 2,
            count: this.count,
            amount,
            prediction,
            isFast: true,
        });
        if (!res || res.error){
            this.iJoinMark = 0;
            return res;
        }
        const oResult = { amount, ...res };
        // console.log("提交结果", deepCopy(oResult)); 
        return oResult;
    },
    // ↓ 机选一个位置（点击“自动选择” 按钮）
    pickAutomatically(){
        const {prediction, count} = this;
        const hasReached = prediction.length + count >= 25;
        if (hasReached) return; // ← 不能再选了
        // ↓ 剩余可选项
        const aTheRest = this.aButList.filter(cur => {
            return !prediction.includes(cur.iNumber);
        }).map(cur => cur.iNumber);
        const iRandomIndex = getRandomInt(0, aTheRest.length - 1);
        const iNumber = aTheRest[iRandomIndex];
        console.log(`可选 ${aTheRest.length} 个，自动选中： ${iNumber}`);
        this.oMusic.oAudio.autoPlay.toPlay();
        if (this.isAutoMode){ // 自动模式
            // ↓ 因为已经按条件禁用按钮，通常不会到这里
            if (this.bDisableAutoPick){
                console.log("都选了，不能再选了");
            }else if (iNumber >= 0){
                prediction.push(iNumber);
            }
        } else if (iNumber >= 0){ // 手动模式
            const oTarget = this.aButList.find(cur=>cur.iNumber === iNumber);
            this.pickManually(oTarget);
        }
    },
    // ----------------------------------------------------------------
    //           ↓ 游戏步骤：开局下注提现 
    // ----------------------------------------------------------------
    // ↓点击【押注】，即游戏开局
    async firstSubmit(){
        this.initTheGame();
        console.log("this.iJoinMark", this.iJoinMark);
        this.iJoinMark = 1; 
        console.log("this.iJoinMark", this.iJoinMark);
        this.oMusic.oAudio.placBet.toPlay();
        const res = await this.toEmitBet({
            "type": 0, // 开局固定为0
            "prediction": [], // 固定为空
            "count": this.round.count, // 炸弹数量
        });
        if (!res || res.error){
            console.error("开局请求报错", res);
            // 在 this.toEmitBet() 内部会按需弹出提示消息，此处不必弹出提示 
        }
        console.log("this.iJoinMark", this.iJoinMark);
    },
    // ↓ 手工选择（用户点击）
    async pickManually(oCurBtn){
        const {iNumber} = oCurBtn;
        console.log("click on:", iNumber);
        const index = this.round.prediction.indexOf(iNumber);
        if (this.isAutoMode) {
            if (index >= 0){
                this.round.prediction.splice(index, 1); // 删除
            }else{
                this.round.prediction.push(iNumber);
            }
            return;
        }
        // ↑ 自动模式时，仅记录用户选择 ------------------------------
        // ↓ 手动模式时，执行提交
        if (index >= 0) return; // 一般不会到这里，因为这表示重复点击
        if (this.isDigging){
            return console.log('连点被驳回; 上次点击未结束');
        }
        this.isDigging = true;
        await this.toEmitBet({
            "type": 1,
            "prediction": iNumber,
        });
        await this.$nextTick();
        this.isDigging = false;
    },
};



export const oMethods = {
    ...oSetGame,
    ...oFnAsAssistant,
    ...oFnBorrowed,
    ...oFnUserTriggered,
};


